import moment from 'moment';
import React from 'react';
import { View, Image } from 'react-native';
import { Icon } from 'react-native-elements';
import Colors from '../../../constants/Colorsv2';
import { TouchableOpacity, Text } from '../../../globalComponents/NativeOverrides';
import { ArticleProps } from '../../../store/types/soc_svc';


type ArticleCardProps = {
    article:ArticleProps,
    width: number,
    truncate_title?:boolean,
    maxWidth?:number,
    show_content?:boolean,
    onArticlePress: (article:ArticleProps) => void
}
const ArticleCard = ({ article, width, maxWidth, truncate_title, show_content, onArticlePress }:ArticleCardProps) => {

    const handleArticlePress = () => {
        if(!onArticlePress){ return }
        onArticlePress(article)
    }


    let article_image = article.image?.url
    if(!article_image || article_image == ''){
        article_image = require('../../../assets/images/default_feed.webp')
    }
    if(width === 0){ return <></> }

    let title = article.title
    if(title.length > 75 && truncate_title){
        title = `${title.slice(0, 75)}...`
    }
    return (
        <TouchableOpacity style={{ margin:5, maxWidth:maxWidth??undefined, backgroundColor:Colors.shades.white, borderRadius:4 }} onPress={() => handleArticlePress()}>
            <View>
                <Image source={article_image} style={{ height:width, width:width, alignSelf:'center' }} resizeMode='cover' />
                {article.article_type == 'video' ?
                <View style={{ position:'absolute', top:0, bottom:0, right:0, left:0, justifyContent:'center', alignItems:'center' }}>
                    <Icon raised name='play' type='feather' size={18} color={Colors.brand.midnight} />
                </View>
                :<></>}
            </View>
            <View style={{ margin:4, padding:5 }}>
                <Text size={14} weight='semibold' color={Colors.shades.black}>{title}</Text>
                <Text size={12} weight='light' color={Colors.shades.black}>{moment(article.publish_datetime).format('dddd')}</Text>
            </View>
            {show_content ?
            <View style={{ margin:4, padding:5, backgroundColor:Colors.shades.shade100 }}>
                <Text size={14} weight='semibold' color={Colors.shades.black}>{article.content_snippet}</Text>
            </View> 
            :<></>}
        </TouchableOpacity>
    )
}

export default ArticleCard